import { themeGet } from 'styled-system';
import styled from 'react-emotion';

export const PriceWrapper = styled('div')`
  margin-left: auto;
  padding-right: 45px;
`;

export const PriceText = styled('span')`
  position: relative;
  font-size: 18px;
  z-index: 1;
  color: ${themeGet('colors.blueDarker')};
  width: auto;
  display: ${props => (props.showPrices ? 'inline-block' : 'none')};
  text-align: right;
`;



// WEBPACK FOOTER //
// ./src/components/price/style.js